const moneyFormatter = new Intl.NumberFormat("da-DK", {
  style: "currency",
  currency: "DKK",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const percentageFormatter = new Intl.NumberFormat("da-DK", {
  style: "percent",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export function formatMoney(value: number) {
  return moneyFormatter.format(value);
}

export function formatReportMoney(currency: string, value: number) {
  const custFormatter = new Intl.NumberFormat("da-DK", {
    style: "currency", // Use currency style
    useGrouping: true, // Use grouping separator
    currencyDisplay: "code", // Use currency code instead of symbol (e.g. DKK instead of kr.)
    currencySign: "accounting", // Use accounting sign for negative values
    currency, // Use the currency provided
    minimumFractionDigits: 0, // Don't show any decimals
    maximumFractionDigits: 0, // Don't show any decimals
  });

  // Only convert to thousands if value is 10000 or greater or -10000 or less
  if (value >= 10000 || value <= -10000) {
    const valueInThousands = value / 1000;
    // Format to parts to get more control over the formatting
    const formatParts = custFormatter.formatToParts(valueInThousands);
    // Find the currency symbol to use in the formatted string
    const currencySymbol = formatParts.find(
      (part) => part.type === "currency",
    )?.value;
    // Return the rest of the formatted string with the currency symbol and add "'" to indicate thousands
    return `${formatParts
      .filter((part) => part.type !== "currency")
      .map((part) => part.value)
      .join("")
      .trim()}' ${currencySymbol}`;
  } else {
    // Use normal formatting for smaller values
    return custFormatter.format(value);
  }
}

export function formatMoneyWithDecimals(value: number) {
  const custFormatter = new Intl.NumberFormat("da-DK", {
    style: "currency",
    currency: "DKK",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return custFormatter.format(value);
}

export function formatMoneyRange(min: number, max: number) {
  return moneyFormatter.formatRange(min, max);
}

export function formatPercentage(value: number) {
  return percentageFormatter.format(value);
}

export function formatPercentageRange(min: number, max: number) {
  return percentageFormatter.formatRange(min, max);
}
